/*jslint node: true*/

"use strict";

var pli = require("pli/forms");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// Define the standard keyboard shortcut
// schema for GeoNexus.  The first key
// combination defined for each entry
// should be used when shortcut is displayed.
pli.keys.setSchema({
    "Accept": "Enter",
    "Back": "Ctrl+Up, Command+Up, Alt+Up",
    "Close": "Esc",
    "Copy": "Ctrl+K, Command+K",
    "Delete": "Ctrl+Delete, Command+Delete",
    "Duplicate": "Ctrl+D, Command+D",
    "Help": "F1",
    "Home": "Ctrl+H, Command+H",
    "Link": "Ctrl+L, Command+L",
    "New": "Ctrl+I, Command+I",
    "NextSibling": "Ctrl+>, Command+>",
    "NextTab": "Ctrl+], Command+]",
    "Open": "Ctrl+O, Command+O",
    "PreviousSibling": "Ctrl+<, Command+<",
    "PreviousTab": "Ctrl+[, Command+[",
    "Print": "Ctrl+P, Command+P",
    "Save": "Ctrl+S, Command+S, F2"
});

//-------------------------------------------
// Define the default keymap for forms
// should be extended by root form and
// modal dialogs
pli.config.defaultKeymap = {
    "Back": false,
    "Close": false,
    "F3": false,
    "F5": false,
    "Help": false,
    "Open": false,
    "Print": false,
    "Save": false
};



//////////////////
// WEBPACK FOOTER
// ./app/geoschema/geoSchema.js
// module id = 512
// module chunks = 49